import { render, staticRenderFns } from "./ServidoresOLTTiposOnu.vue?vue&type=template&id=4d2789b5&"
import script from "./ServidoresOLTTiposOnu.vue?vue&type=script&lang=js&"
export * from "./ServidoresOLTTiposOnu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports